<button mat-icon-button [matTooltip]="tooltip" [color]="color" (click)="onClick()">
    <img src="assets/images/icons/View-icon-20px.png" alt="Button Image" height="17">
  </button>
  